module.exports={close:"Luk",error:"Fejl",info:"Oplysninger",success:"Fuldført",warning:"Advarsel"};